import type { ReactNode } from 'react';

export const symbol_align_justify_flex_end: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M828.5-88.63Q820-97.25 820-110v-740q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v740q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM600-290q-12.75 0-21.37-8.63Q570-307.25 570-320v-320q0-12.75 8.63-21.38Q587.25-670 600-670h40q12.75 0 21.38 8.62Q670-652.75 670-640v320q0 12.75-8.62 21.37Q652.75-290 640-290h-40Zm-240 0q-12.75 0-21.37-8.63Q330-307.25 330-320v-320q0-12.75 8.63-21.38Q347.25-670 360-670h40q12.75 0 21.38 8.62Q430-652.75 430-640v320q0 12.75-8.62 21.37Q412.75-290 400-290h-40Z"
		/>
	</svg>
);
